<script setup lang="ts">
import { ApiPlate } from '~/components/api-plate'
import { CountryTips } from '~/components/country-tips'
import Banner from './components/Banner.vue'
import Faqs from './components/Faqs.vue'
import Introduce from './components/Introduce.vue'
import Partner from './components/Partner.vue'
import StatisticsClient from './components/Statistics.client.vue'
import TGRobotics from './components/TGRobotics.vue'
import Transaction from './components/Transaction.vue'
</script>

<template>
  <div>
    <!-- 用于 -->
    <NuxtLinkLocale class="hidden" to="/payment-result" data-test-id="bWAs" />
    <NuxtLink class="hidden" to="/payment-result" data-test-id="Yve0" />

    <CountryTips class="lt-tabletl:hidden" />
    <Banner />

    <StatisticsClient />
    <Transaction />
    <TGRobotics />
    <Introduce class="introduce" />
    <Faqs />
    <ApiPlate />
    <Partner />

    <ClientOnly>
      <Announcement pos="1" />
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped>
</style>
